import React, { useRef, useEffect } from "react";

const SMOKE_COLOR = "rgba(15,15,25,0.88)";
const CLEAR_RADIUS = 220;

export default function SmokeReveal() {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    let width = window.innerWidth;
    let height = window.innerHeight;

    const resize = () => {
      width = window.innerWidth;
      height = window.innerHeight;
      canvas.width = width;
      canvas.height = height;
      renderSmoke();
    };
    window.addEventListener("resize", resize);

    function renderSmoke(cx = -999, cy = -999) {
      ctx.clearRect(0, 0, width, height);
      ctx.fillStyle = SMOKE_COLOR;
      ctx.fillRect(0, 0, width, height);

      ctx.save();
      ctx.globalCompositeOperation = "destination-out";
      const BIG_RADIUS = CLEAR_RADIUS * 1.8;
      const grad = ctx.createRadialGradient(cx, cy, BIG_RADIUS * 0.6, cx, cy, BIG_RADIUS);
      grad.addColorStop(0, 'rgba(0,0,0,1)');
      grad.addColorStop(1, 'rgba(0,0,0,0)');
      ctx.fillStyle = grad;
      ctx.beginPath();
      ctx.arc(cx, cy, BIG_RADIUS, 0, Math.PI * 2, false);
      ctx.fill();
      ctx.restore();

      ctx.globalCompositeOperation = "lighter";
      ctx.fillStyle = "rgba(30,30,45,0.10)";
      ctx.beginPath();
      ctx.arc(cx, cy, BIG_RADIUS, 0, Math.PI * 2, false);
      ctx.fill();
      ctx.globalCompositeOperation = "source-over";
    }

    function onMouseMove(e) {
      renderSmoke(e.clientX, e.clientY);
    }

    window.addEventListener("mousemove", onMouseMove);
    renderSmoke();

    return () => {
      window.removeEventListener("mousemove", onMouseMove);
      window.removeEventListener("resize", resize);
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        pointerEvents: "none",
        width: "100vw",
        height: "100vh",
        zIndex: 2,
        mixBlendMode: "multiply"
      }}
      width={window.innerWidth}
      height={window.innerHeight}
      aria-hidden
    />
  );
}
